import React from 'react';
import Deadlines from '../deadlines/deadlines';
import './footer.css';
import { Goback } from '../nav/nav';
import { blogvisible } from '../main/main';
import { useTranslation } from 'react-i18next';
function Footer(props) {
  const { t } = useTranslation();
  return (
    <div className="footer">
      <div style={{ marginBottom: 'clamp(5px,0.5vh,10px)' }}>
        <span
          onClick={() => {
            blogvisible('open');
          }}
        >
          {t('services-footer-Blog')}
        </span>
        {/* <i class="bi bi-dot dot"></i>
        <span>Case Study</span> */}
        <i className="bi bi-dot dot"></i>
        <span onClick={props.onVideosOpen}>{t('services-footer-Video')}</span>
        <i className="bi bi-dot dot"></i>
        <span onClick={props.onFormsOpen}>{t('services-footer-Form')}</span>
        <i className="bi bi-dot dot"></i>
        <span onClick={props.onCalculatorOpen}>
          {t('services-footer-Calculator')}
        </span>
      </div>
      <Deadlines />
      <div className="icons">
        <a target="_self" rel="noopener noreferrer" href={`tel: +919292300345`}>
          {' '}
          <i className=" fa fa-phone" style={{ margin: '0px 4px' }}></i>
        </a>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={
            'https://api.whatsapp.com/send/?phone=9292300345&text&app_absent=0'
          }
        >
          {' '}
          <i className=" fa fa-whatsapp" style={{ margin: '0px 4px' }}></i>
        </a>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={`https://telegram.me/make05`}
        >
          {' '}
          <i className=" fa fa-telegram" style={{ margin: '0px 4px' }}></i>
        </a>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={
            'https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=samskrithigoshala@gmail.com'
          }
        >
          {' '}
          <i className=" fa fa-envelope" style={{ margin: '0px 4px' }}></i>
        </a>
        {props.goback && <Goback />}
      </div>
    </div>
  );
}
export default Footer;
